export default __webpack_public_path__ + "static/media/pug.0e7f7c55.svg";